import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./Skills.css";

// `homelab: true` marks skills practiced in my personal Proxmox homelab,
// not in a professional systems administration role.
const skillGroups = [
  {
    title: "Linux & Systems Administration",
    homelab: true,
    skills: [
      "Ubuntu Server",
      "Rocky Linux",
      "Windows Server",
      "Proxmox VE",
      "Virtual machines and LXC containers",
      "SSH / remote administration",
    ],
  },
  {
    title: "Networking & Hosted Services",
    homelab: true,
    skills: [
      "TCP/IP and DNS fundamentals",
      "Network troubleshooting",
      "Pi-hole",
      "Nginx",
      "Cloudflare Tunnel",
      "Uptime Kuma",
      "GitHub Actions for website deployment",
    ],
  },
  {
    title: "Full-Stack Web Development",
    skills: [
      "C# / .NET",
      "ASP.NET Core Web API",
      "Angular",
      "TypeScript / JavaScript",
      "SQL Server / T-SQL",
      "Dapper",
      "React",
      "Python / Flask",
      "REST APIs",
      "HTML / CSS",
    ],
  },
  {
    title: "QA & Troubleshooting",
    skills: [
      "Manual testing",
      "Functional and regression testing",
      "Integration testing",
      "Test case design and execution",
      "Requirements validation",
      "SQL / database validation",
      "Defect reporting and retesting",
      // TODO(verify): Postman was listed on the previous Skills page but is
      // not mentioned in any role or project description.
      "API testing with Postman",
    ],
  },
  {
    title: "Tools",
    skills: [
      "Git / GitHub",
      "Jira",
      "Azure DevOps",
      "SQL Server Management Studio",
      "LabVIEW / TestStand",
      "Excel",
    ],
  },
];

class Skills extends Component {
  render() {
    return (
      <div className="Page">
        <div className="PageContainer">
          <h1 className="PageHeading">Skills</h1>
          <p className="PageIntro">
            Groups marked <span className="Label">Homelab Practice</span>
            reflect hands-on skills I’m developing in my personal Proxmox
            homelab. The other groups draw from my professional software
            development and QA experience, coursework, and projects.
          </p>
          <div className="row g-4">
            {skillGroups.map((group) => (
              <section className="col-md-6" key={group.title}>
                <div className="Card">
                  <h2 className="SkillCardTitle">{group.title}</h2>
                  {group.homelab && (
                    <p className="SkillSource">
                      <span className="Label">Homelab Practice</span>
                    </p>
                  )}
                  <ul className="BadgeWrap SkillList">
                    {group.skills.map((skill) => (
                      <li className="Badge" key={skill}>
                        {skill}
                      </li>
                    ))}
                  </ul>
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Skills;
